import React, { useEffect, useRef, useState } from 'react';

import { ModelDefinitionDto, ModelRequestDtoCompact, ModelReview, RepositoryDto } from '../models/APIModels';
import Rating from '@mui/material/Rating';
import { FaThumbsUp, FaTrash } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { ApiHelper } from '../common/ApiHelper';
import { useAuth0 } from '@auth0/auth0-react';
import { LocalStorageService } from '../common';
import useAppUtils from '../Utils/useAppUtils';
import StarIcon from '@mui/icons-material/Star';
import { ReviewModal } from './Modals';
import hostedModelLogo from '../../images/logo/FullLogo_Transparent_NoBuffer.png'
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Loader from './Loader';
import favicon from '../../public/images/favicon.ico';
import { red } from '@mui/material/colors';
import { Direction } from 'react-toastify/dist/utils';

interface IProps {
  type: string;
  searchItem?: ModelDefinitionDto | ModelRequestDtoCompact | null;
  repositoryItem?: RepositoryDto | null;
  // modelRequestItem?: ModelRequest | null;
  reviewItem?: ModelReview | null;
  onItemClick?: (item) => void;
  onActionClick?: (item, type) => void;
  itemKey?: string;
}
const defaultReview = {
  reviewTitle: '',
  reviewText: '',
  starRating: 0,
};
const ItemContent = ({
  type,
  searchItem = null,
  repositoryItem = null,
  reviewItem = null,
  onItemClick = null,
  onActionClick = null,
  itemKey,
}: IProps) => {
  const [repositoryModal, setRepositoryModal] = useState(false);
  // const [likes, setLikes] = useState(searchItem?.socialStatus?.likes ?? 0);
  const [starRating, setStarRating] = React.useState<number | null>(searchItem?.socialStatus?.averageStarRating ?? 0);
  const { alert, confirm } = useAppUtils();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const Desktop = useMediaQuery('(min-width:1200px)');
  const Ipad = useMediaQuery('(min-width:1000px)');
  const Mobile = useMediaQuery('(min-width:600px)');


  return (
    <Grid container>
      <Grid item xs={12}>
        <Card className="card-search">


          {type === 'mymodels' && searchItem && (
            <>
              {/* Desktop view - displaying search results for models..... */}
              {Mobile && (
                <CardContent className="card-content-section">
                  <img
                    src={searchItem?.favIconUrl}
                    alt="favicon-img"
                    loading="lazy"
                    className="fav-icon"
                    onError={(e) => {
                      e.target.onError = null;
                      e.target.src = favicon;
                    }}
                  />
                  <Divider
                    color="#ddd"
                    orientation="vertical"
                    variant="middle"
                    sx={{ height: 'auto', width: '3px', marginLeft: '6px', marginRight: '10px', marginTop: '5px' }}
                  />
                  <div>
                    <h5 className="card-title">
                      <NavLink to={`/models/${searchItem.modelId}/view`} className="nav-link active">
                        {searchItem.modelName}
                      </NavLink>
                    </h5>
                    <p>{searchItem.modelDescription}</p>
                  </div>
                  <Stack spacing={1} sx={{ marginLeft: 'auto' }}>
                    <div className='hosted-model-logo'>
                      
                      <Rating
                        name="simple-controlled"
                        value={starRating}
                        readOnly
                        emptyIcon={<StarIcon style={{ opacity: 0.55 }} />}
                      // precision={0.5}
                      />

                      <div>
                        {searchItem?.modelType === 'HostedModel' && (<>
                          <img
                            src={hostedModelLogo}
                            alt="gosted-model-logo"
                            loading="lazy"
                            width={100}

                            style={{ marginTop: '10px' }}
                            onError={(e) => {
                              e.target.onError = null;
                              e.target.src = favicon;
                            }}
                          />
                        </>)}
                      </div>


                    </div>
                  </Stack>
                </CardContent>
              )}
              {/* Mobile view - displaying search results for models..... */}
              {!Mobile && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <CardHeader
                      style={{ padding: '10px 16px 0px 16px', flex: '3' }}
                      title={
                        <h5 className="card-title-for-mobile">
                          <NavLink to={`/models/${searchItem.modelId}/view`} className="nav-link active">
                            {searchItem.modelName}
                          </NavLink>
                        </h5>
                      }
                      subheader={
                        <Stack spacing={1} sx={{ marginLeft: 'auto' }}>
                          <Rating
                            name="simple-controlled"
                            value={starRating}
                            readOnly
                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} />}
                          // precision={0.5}
                          />
                        </Stack>
                      }
                    />
                    <div style={{ margin: '5px 10px 10px auto', flex: '1', textAlign: 'center' }}>
                      <img
                        src={searchItem?.favIconUrl}
                        alt="favicon-img"
                        loading="lazy"
                        className="fav-icon fav-icon-mobile"
                        onError={(e) => {
                          e.target.onError = null;
                          e.target.src = favicon;
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ padding: '0px 16px 16px 16px' }}>
                    <p>{searchItem.modelDescription}</p>
                  </div>
                </>
              )}
            </>
          )}


          {type === 'ModelRequest' && searchItem && (
            <CardContent className="card-content-section">
              <div style={{ flex: '3' }}>
                {onActionClick && (
                  <h5 className="card-title">
                    {' '}
                    <span className="nav-link cursor-pointer  active" onClick={(e) => onActionClick(searchItem, 'view')}>
                      {searchItem.requestTitle}{' '}
                    </span>
                  </h5>
                )}
                <p className="description-content">{searchItem.requestDescription}</p>
              </div>
              <div style={{ display: 'flex' }}>
                {onActionClick && (
                  <p className="social-status ">
                    <FaThumbsUp
                      className="cursor-pointer"
                      color={searchItem?.socialStatus?.likes > 0 ? '#2596be' : ''}
                      onClick={() => onActionClick(searchItem, 'like')}
                    />
                    <span style={{ padding: '5px' }}>
                      {searchItem?.socialStatus?.likes > 0 ? searchItem?.socialStatus?.likes : ''}
                    </span>
                  </p>
                )}
                {/* <div style={{marginTop:'0px', marginLeft:'2px'}}>
                  {onActionClick && <FaTrash color="info" title="Delete" className="cursor-pointer" onClick={(e) => onActionClick(searchItem, 'delete')}/>}
                  </div> */}
              </div>
            </CardContent>
          )}


          {/* {type === 'repository' && repositoryItem && (
            <CardBody>
              <Row>
                <Col md="12" xs="12">
                  <CardTitle tag="h5">
                    <span className="nav-link cursor-pointer active">{repositoryItem.repositoryName}</span>
                  </CardTitle>
                  <p>{repositoryItem.repositoryDescription}</p>
                </Col>
              </Row>
            </CardBody>
          )} */}


          {type === 'review' && reviewItem && (
            <CardContent className="card-content-section">
              <div style={{ flex: '3' }}>
                <h5 className="card-title">{reviewItem.reviewTitle}</h5>
                {reviewItem?.userPublicName && (
                  <p className="author">
                    Reviewer:{' '}
                    <NavLink
                      to={`/profile/${reviewItem.userPublicName}`}
                      className="nav-link active"
                      style={{ display: 'inline-block' }}
                    >
                      {reviewItem.userPublicName}
                    </NavLink>
                  </p>
                )}
                <p>{reviewItem.reviewText}</p>
              </div>
              <Rating
                name="simple-controlled"
                value={reviewItem.starRating ?? 0}
                readOnly
              // precision={0.5}
              />

            </CardContent>
          )}





        </Card>
      </Grid>
    </Grid>
  );
};

export default ItemContent;
